import { atom } from 'recoil';

/**
 * Action currently focused via deep-link (`?actionId=`).
 * Used to temporarily highlight a card with a distinct box-shadow.
 */
export const focusedActionId = atom<string | null>({
  key: 'focusedActionId',
  default: null,
});

export default focusedActionId;
